import { Address } from './trip.types'

export const formatAddress = ({ street, city, state }: Address): string => {
  return `${street}, ${city}, ${state}`
}

export const convertToTitleCase = (text: string) => {
  text = text.toLowerCase()
  return text.charAt(0).toUpperCase() + text.slice(1)
}
